// hook for library data
import useSWR from 'swr';

import axios from 'axios';

export function useLibrary(folderId, shared = false) {
   // useSWR hook to get library data
   const library = useSWR(
      shared
         ? `/api/library/shared?${folderId ? `parentFolderId=${folderId}` : ''}`
         : `/api/library?parentFolderId=${folderId ? folderId : ''}`
   );

   /**
    * method to add new file and update cached data
    */
   const moveFile = async (fileId, newFolderId) => {
      // update library data
      const res = await axios.patch(`/api/library/file/${fileId}`, {
         parentFolder: newFolderId,
      });
      // mutate library data
      const newLibrary = { ...library.data };
      newLibrary.files.find((file) => file._id == fileId).folder = newFolderId;
      library.mutate({
         ...newLibrary,
         // remove moved file from current folder
         files: newLibrary.files.filter((file) => file._id != fileId),
      });
   };

   /**
    * method to update file and update cached data
    */
   const updateFile = (fileId, newFile) => {
      // update library data
      // ...
      // mutate library data
      const newLibrary = { ...library.data };
      const oldFile = newLibrary.files.find((file) => file._id == fileId);
      newLibrary.files[newLibrary.files.indexOf(oldFile)] = {
         ...oldFile,
         ...newFile,
      };
      library.mutate({ ...newLibrary });
   };

   /**
    * method to add new file and update cached data
    */
   const moveFolder = async (folderId, newFolderId) => {
      // update library data
      const res = await axios.patch(`/api/library/folder/${folderId}`, {
         parentFolderId: newFolderId,
      });

      if (res.statusText != 'OK') return;

      // mutate library data
      const newLibrary = { ...library.data };
      newLibrary.folders.find((folder) => folder._id == folderId).parent = newFolderId;
      library.mutate({
         ...newLibrary,
         // remove moved folder from current folder
         folders: newLibrary.folders.filter((folder) => folder._id != folderId),
      });
   };

   const updateFolder = async (folderId, newData) => {
      // update library data
      await axios.patch(`/api/library/folder/${folderId}`, newData);
      // mutate library data
      const newLibrary = { ...library.data };
      const oldFolder = newLibrary.folders.find((folder) => folder._id == folderId);
      newLibrary.folders[newLibrary.folders.indexOf(oldFolder)] = {
         ...oldFolder,
         ...newData,
      };
      library.mutate({ ...newLibrary });
   };

   // method to add new folder and update cached data
   const addNewFolder = async (folder) => {
      // update library data
      const newFolder = await axios.post(`/api/library/folder`, folder);
      if (newFolder.statusText != 'OK') return;
      // mutate library data
      const newLibrary = { ...library.data };
      if (folder.parentFolderId == folderId) {
         newLibrary.folders.push(newFolder.data.folder);
         library.mutate({ ...newLibrary });
      }
   };

   // method to delete folder and update cached data
   const deleteFolder = (folderId) => {
      // update library data
      const res = axios.delete(`/api/library/folders/${folderId}`);
      if (res.statusText != 'OK') return;
      const deletedFolder = res.data.deletedFolder;

      // mutate library data
      const newLibrary = { ...library.data };
      newLibrary.folders = newLibrary.folders.filter((folder) => folder._id != deletedFolder._id);
      library.mutate({ ...library.data });
   };

   // method to bulk delete files and folders and update cached data
   const bulkDelete = async (allIds) => {
      // update library data
      const res = await axios.delete(`/api/library`, { data: { ids: allIds } });
      if (res.statusText != 'OK') return;

      // mutate library data
      const newLibrary = { ...library.data };
      newLibrary.folders = newLibrary.folders.filter((folder) => !allIds.includes(folder._id));
      newLibrary.files = newLibrary.files.filter((file) => !allIds.includes(file._id));
      library.mutate({ ...newLibrary });
   };

   return {
      ...library,
      moveFolder,
      addNewFolder,
      updateFolder,
      deleteFolder,
      moveFile,
      updateFile,
      bulkDelete,
   };
}
